import { render, staticRenderFns } from "./SearchResponsesItemStudyContext.vue?vue&type=template&id=5aa07840&scoped=true"
import script from "./SearchResponsesItemStudyContext.vue?vue&type=script&lang=js"
export * from "./SearchResponsesItemStudyContext.vue?vue&type=script&lang=js"
import style0 from "./SearchResponsesItemStudyContext.vue?vue&type=style&index=0&id=5aa07840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa07840",
  null
  
)

export default component.exports